import { Box, CircularProgress } from "@mui/material";

const MuiLoadingContainer = () => (
  <Box m={4} display="flex" justifyContent="center" height="100%" alignItems="center">
    <CircularProgress />
  </Box>
);

export default MuiLoadingContainer;
